import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'
import { COLUMN_BYTES } from '../../../lib/columnBytes'

/** DB kolon tanımıyla birebir uzunluk sınırları (059 spec FR-030). */
export const NAME_MAX_LEN = 100
export const DESCRIPTION_MAX_LEN = 1000
export const STATIC_CONTENT_MAX_LEN = 4000

/**
 * Şablon Parametresi **düzenleme** form şeması (059 US4).
 *
 * **Şema yalnız DÜZENLENEBİLİR alanları içerir**: ad, açıklama ve (kayıt statikse) statik içerik.
 * **Grup**, **parametre kodu** (2026-08-04) ve **"Statik mi?"** (2026-08-05) formda salt-okunur
 * gösterilir → şemada yer almazlar; gönderim gövdesine düzenlenen kaydın kendi değerlerinden konur.
 * Böylece "değişmeyecek bir alanın doğrulanması" gibi ölü bir kural kalmaz ve bu alanların kazara
 * değişmesi yapısal olarak imkânsızdır.
 *
 * **`staticContent` zorunluluğu bir ALAN kuralı değil, FORM kuralıdır** — ama artık forma girilen bir
 * değere değil, **düzenlenen kaydın kendi `isStatic` değerine** bağlıdır (`staticRequired`): kayıt
 * statikse alan görünür ve **boş bırakılamaz** (FR-028; aksi halde şablonda boş bir yer tutucuya
 * dönüşür), statik değilse alan hiç render edilmez. Kural `superRefine` ile şema düzeyinde uygulanır
 * ve hata `staticContent` alanına iliştirilir (kullanıcı hatayı doğru alanın altında görür).
 *
 * "Statik mi?" artık değişmediği için `staticRequired` **form açılışında sabittir**; şema yine bir
 * **fabrika**dır çünkü bayrak düzenlenen kayda göre farklıdır (ve "Evet" kimliği koda gömülmez —
 * sunucudan gelen `StaticOption.yes` bayrağından türetilir, research D14).
 */
export function makeTemplateParameterFormSchema(staticRequired: boolean) {
  return z
    .object({
      nameTr: requiredText(NAME_MAX_LEN, COLUMN_BYTES.templateParameterName),
      nameEn: optionalText(NAME_MAX_LEN, COLUMN_BYTES.templateParameterName),
      descriptionTr: optionalText(DESCRIPTION_MAX_LEN, COLUMN_BYTES.referenceText),
      descriptionEn: optionalText(DESCRIPTION_MAX_LEN, COLUMN_BYTES.referenceText),
      staticContent: optionalText(STATIC_CONTENT_MAX_LEN, COLUMN_BYTES.templateStaticContent),
    })
    .superRefine((values, ctx) => {
      if (staticRequired && values.staticContent.trim() === '') {
        ctx.addIssue({
          code: 'custom',
          path: ['staticContent'],
          message: 'validation.required',
        })
      }
    })
}

export type TemplateParameterFormValues = z.infer<
  ReturnType<typeof makeTemplateParameterFormSchema>
>
